/* @flow */

import * as React from 'react';

import FormBuilderText from './fields/FormBuilderText';
import FormBuilderRating from './fields/FormBuilderRating';
import FormBuilderCheckbox from './fields/FormBuilderCheckbox';
import FormBuilderCheckboxList from './fields/FormBuilderCheckboxList';

import type { Field } from './type/formBuilderTypes';

const componentsList = {
  checkbox_list: FormBuilderCheckboxList,
  rating: FormBuilderRating,
  checkbox: FormBuilderCheckbox,
  text: FormBuilderText,
};

const FormBuilderField = ({
  field,
  type,
  name,
  parentName,
  'aria-describedby': ariaDescribedby,
}: Field): React.Node => {
  const Component = componentsList[type];

  if (!Component) return null;
  return (
    <Component
      field={field}
      type={type}
      name={name}
      parentName={parentName}
      aria-describedby={ariaDescribedby}
    />
  );
};

export default React.memo<Field>(FormBuilderField);
